import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PwaUpdateBannerComponent } from "./pages/shared/pwa-update-banner/pwa-update-banner.component";

const LANG_STORAGE_KEY = "kiraah-mobile-lang";
const SUPPORTED = new Set(["fr", "en", "de", "es", "it", "pt"]);

@Component({
  selector: "mobile-root",
  imports: [RouterOutlet, PwaUpdateBannerComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  ngOnInit(): void {
    try {
      const raw = localStorage.getItem(LANG_STORAGE_KEY)?.toLowerCase().split("-")[0];
      if (raw && SUPPORTED.has(raw)) {
        void this.translate.use(raw);
      }
    } catch {
      /* ignore */
    }
  }
}
